import { CurrencyFormatter } from '@mixins/currency-formatter-mixin';
import { format } from '@mixins/decimal';
import Model from '@models/model';

export default class ProposalEquipment extends Model {
    item = {};

    vendor = {};

    resource() {
        return 'equipment';
    }

    get formFieldCasts() {
        return {
            cost: CurrencyFormatter.formFormat,
            price: CurrencyFormatter.formFormat,
        };
    }

    get propCasts() {
        return {
            qty: format,
        };
    }
}
